import classnames from 'classnames'

/** The row class DataView puts on every body row, so the platform's DataView row rules reach the dashboard's rows. */
export const DASHBOARD_TABLE_ROW_CLASS_NAME = 'data-view-row'

/** DataView draws its tables at antd's small size; the loaded tables and their placeholders must agree on it. */
export const DASHBOARD_TABLE_SIZE = 'small' as const

/**
 * The classes every dashboard table carries: DataView's own table class, so the platform's table rules apply, and
 * the table's own class. The loaded table and its placeholder both take their class from here, so the two cannot
 * differ in how the platform's rules treat them.
 */
export const dashboardTableClassName = (tableClassName: string): string =>
    classnames('ghost', 'data-view-table', tableClassName)
